// extracted by mini-css-extract-plugin
export var linkButton = "link-button-default-module--link-button--3yqMx";